import type { ReactElement } from "react";

export function EyeIcon(): ReactElement {
  return (
    <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#eye-clip)">
        <path
          opacity="0.4"
          d="M0.0781372 7.61562C-0.0249878 7.8625 -0.0249878 8.1375 0.0781372 8.38437C0.543762 9.5 1.52189 11.125 2.98439 12.4812C4.45626 13.8469 6.47814 15 9.00314 15C11.5281 15 13.55 13.85 15.0219 12.4812C16.4844 11.1219 17.4625 9.5 17.9281 8.38437C18.0313 8.1375 18.0313 7.8625 17.9281 7.61562C17.4625 6.5 16.4844 4.875 15.0219 3.51875C13.55 2.15312 11.5281 1 9.00314 1C6.47814 1 4.45314 2.15 2.98126 3.51875C1.51876 4.875 0.540637 6.5 0.0781372 7.61562ZM13.5 8C13.5 9.19347 13.0259 10.3381 12.182 11.182C11.3381 12.0259 10.1935 12.5 9.00001 12.5C7.80654 12.5 6.66195 12.0259 5.81803 11.182C4.97412 10.3381 4.50001 9.19347 4.50001 8C4.50001 6.80653 4.97412 5.66193 5.81803 4.81802C6.66195 3.97411 7.80654 3.5 9.00001 3.5C10.1935 3.5 11.3381 3.97411 12.182 4.81802C13.0259 5.66193 13.5 6.80653 13.5 8Z"
          fill="currentColor"
        />
        <path
          d="M9.00001 6C9.00001 7.10312 8.10314 8 7.00001 8C6.64064 8 6.30314 7.90625 6.00939 7.7375C5.97814 8.07812 6.00626 8.42812 6.10001 8.775C6.52814 10.375 8.17501 11.325 9.77501 10.8969C11.375 10.4687 12.325 8.82187 11.8969 7.22187C11.5156 5.79375 10.1625 4.88437 8.73751 5.00937C8.90314 5.3 9.00001 5.6375 9.00001 6Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="eye-clip">
          <rect width="18" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
